export default __webpack_public_path__ + "static/media/set_2_Image-1.f23f5427.svg";